"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.REG_EXP_LIST = void 0;
var REG_EXP_LIST;
(function (REG_EXP_LIST) {
    REG_EXP_LIST["enUtf8AndSpecialCharts"] = "^[\\A-Za-z\\ \\@\\d\\+\\-\\=\\.\\_\\:\\/]*$";
    REG_EXP_LIST["onlyAscii"] = "^[\0-]*$";
    REG_EXP_LIST["dnsName"] = "^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$";
    REG_EXP_LIST["email"] = "^(([^<>()[\\]\\\\.,;:\\s@\"]+(\\.[^<>()[\\]\\\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$";
    REG_EXP_LIST["userAccount"] = "^[a-z_][a-z0-9_-]*\\$?$";
    REG_EXP_LIST["cyrillic"] = "[\u0430-\u044F\u0410-\u042F]+";
    REG_EXP_LIST["url"] = "^(http(s)?):\\/\\/(\\w+:{0,1}\\w*@)?(\\S+)(:[0-9]+)?(\\/|\\/([\\w#!:.?+=&%@!\\-\\\\/]))?";
})(REG_EXP_LIST = exports.REG_EXP_LIST || (exports.REG_EXP_LIST = {}));
//# sourceMappingURL=regExpList.js.map